import { brandIsPh } from '@/shared/config/brand-by-target.mjs';

// mobile-only icon overrides (all brands) — only applied at render time (isMobile),
// never baked into shared BANNERS_DATA, so desktop stays untouched
export const MOBILE_ICON_OVERRIDES: Record<number, string> = {
  1: '/images/icons/minibanners_new/slots_new.png',
  7: '/images/icons/minibanners_new/casino_new.png',
  2: '/images/icons/minibanners_new/bids_new.png',
  3: '/images/icons/minibanners_new/fast_new.png',
  4: '/images/icons/minibanners_new/liveDealer_new.png',
  5: '/images/icons/minibanners_new/desktop_new.png',
  6: '/images/icons/minibanners_new/favourites_new.png',
  11: brandIsPh
    ? '/images/icons/minibanners_new/rewards_new.png'
    : '/images/icons/minibanners_new/bonus_new.png',
  10: '/images/icons/minibanners_new/cashback_new.png',
  13: '/images/icons/minibanners_new/promoCodes_new.png',
  14: '/images/icons/minibanners_new/support_new.png',
  15: brandIsPh
    ? '/images/icons/minibanners_new/mysteryBox_new.png'
    : '/images/icons/minibanners_new/shop_new.png',
  24: '/images/icons/minibanners_new/fortune-wheel_new.png',
  25: '/images/icons/minibanners_new/lottery_new.png',
  31: '/images/icons/minibanners_new/rebate_new.png',
  32: '/images/icons/minibanners_new/db_new.png',
};
